import React, { useContext } from "react";
import Footer from "../components/Footer";
import axios from "axios";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Global from "../util/Global";
import { LoaderComponent } from "../util/Loader";
import NewsFilter from "../components/News/NewsComponents";
import NewsComponent from "../components/News/NewsComponent";
import { AlertContext } from "../util/Alerter";



const Actualite = () => {
  const { t } = useTranslation();
  const { showAlert } = useContext(AlertContext)
  const [filteredList, setFilteredList] = useState([]);
  const [newsList, setnewsList] = useState([]);
  const [isLoading, setisLoading] = useState(true)


  const NEWS_URL = Global.backend + "/index.php/actualite/showall";




  useEffect(() => {
    setisLoading(true)

    axios.all([axios.get(NEWS_URL)])
      .then(axios.spread((newsResponse) => {
        setnewsList(newsResponse.data);
      })).catch((err) => {
        showAlert("error", t("request.errorFetchingNews"))
      })
      .finally(() => {
        setisLoading(false)
      })
  }, []);








  return (
    <div>
      <LoaderComponent isLoading={isLoading}>
        <main
          className="my-main ttm-bgcolor-grey"
          style={{
            minHeight: "calc(100vh + 700px)",
          }}
        >
          <div className="container-fluid bg-trasparent my-4 p-3">
            <div className="row">
              <NewsFilter title={t("navigation8.1")} newsList={newsList} setFilteredList={setFilteredList} />

              <div className="col-md-9">
                <div className="container-fluid">
                  <NewsComponent itemsPerPage={8} items={filteredList} />
                </div>
              </div>
            </div>
          </div>


        </main>
      </LoaderComponent>
      <Footer />
    </div>
  )

};

export default Actualite;
